import React from "react";
import pluri from "../img/pluri.png";
import Button from "./Button";
import { useNavigate } from "react-router-dom";

const ErrorBoundary = () => {
  const navigate = useNavigate();
  return (
    <div className="errorPages">
      <div className="errorContent">
        <img src={pluri} alt="ourLogo" className="errpng" />
        <h1>ERROR 404</h1>
        <p>Page not found</p>
        <Button variant="secondary" onClick={() => navigate("/home")} className="errbtn">
          Go back{" "}
        </Button>
      </div>
    </div>
  );
};

export default ErrorBoundary;
